const styles = {
    textArea: {
        minHeight: 50,
        resize: 'vertical'
    }
};

export default styles;
